var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex justify-content-end mt-2" }, [
    _c(
      "div",
      _vm._l(_vm.options, function(option) {
        return _c(
          "span",
          {
            key: option.code,
            staticClass: "mr-2",
            class: { active: _vm.active === option.code },
            on: {
              click: function($event) {
                return _vm.setLanguage(option.code)
              }
            }
          },
          [_vm._v(_vm._s(option.name))]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }